import { CheckCircle2, AlertTriangle, Clock, Package, XCircle, Circle, Wrench } from "lucide-react";

// tone -> dark neon glass styling
const TONE = {
  green: { bg: "rgba(0, 220, 130, 0.14)", text: "#5EEBB0", border: "rgba(0, 220, 130, 0.55)", glow: "0 0 10px rgba(0,220,130,0.35)" },
  blue:  { bg: "rgba(0, 180, 255, 0.14)", text: "#5CC8FF", border: "rgba(0, 200, 255, 0.55)", glow: "0 0 10px rgba(0,200,255,0.4)" },
  amber: { bg: "rgba(255, 190, 0, 0.14)", text: "#FFD65C", border: "rgba(255, 200, 0, 0.55)", glow: "0 0 10px rgba(255,200,0,0.3)" },
  red:   { bg: "rgba(255, 60, 90, 0.14)", text: "#FF8CA3", border: "rgba(255, 80, 110, 0.6)", glow: "0 0 10px rgba(255,80,110,0.4)" },
  gray:  { bg: "rgba(120, 160, 210, 0.10)", text: "#9DB6D6", border: "rgba(120, 160, 210, 0.4)", glow: "none" },
};

const MAP = {
  COMPLETE: { tone: "green", icon: CheckCircle2, label: "COMPLETE" },
  MATCHED: { tone: "green", icon: CheckCircle2, label: "MATCHED" },
  MATCH: { tone: "green", icon: CheckCircle2, label: "MATCH" },
  INSTALLED: { tone: "green", icon: CheckCircle2, label: "INSTALLED" },
  ISSUED: { tone: "blue", icon: Package, label: "ISSUED" },
  PARTIAL: { tone: "amber", icon: AlertTriangle, label: "PARTIAL" },
  REVIEW: { tone: "amber", icon: AlertTriangle, label: "REVIEW" },
  POSSIBLE: { tone: "amber", icon: AlertTriangle, label: "POSSIBLE" },
  NEED_MATCHING: { tone: "amber", icon: AlertTriangle, label: "NEED MATCHING" },
  PROBLEM: { tone: "red", icon: XCircle, label: "PROBLEM" },
  UNMATCHED: { tone: "red", icon: XCircle, label: "UNMATCHED" },
  NO_MATCH: { tone: "red", icon: XCircle, label: "NO MATCH" },
  OVER: { tone: "red", icon: AlertTriangle, label: "OVER RECEIVED" },
  WAITING: { tone: "gray", icon: Clock, label: "WAITING" },
  PARTS_WAITING: { tone: "gray", icon: Clock, label: "PARTS WAITING" },
  PARTS_PARTIAL: { tone: "amber", icon: AlertTriangle, label: "PARTS PARTIAL" },
  PARTS_COMPLETE: { tone: "green", icon: CheckCircle2, label: "PARTS COMPLETE" },
  NOT_ORDERED: { tone: "gray", icon: Circle, label: "NOT ORDERED" },
  PARTIALLY_ORDERED: { tone: "amber", icon: AlertTriangle, label: "PARTIALLY ORDERED" },
  ORDERED: { tone: "blue", icon: Package, label: "ORDERED" },
  ALL_ORDERED: { tone: "green", icon: CheckCircle2, label: "ALL ORDERED" },
  OVERDUE: { tone: "red", icon: AlertTriangle, label: "OVERDUE" },
  OVERDUE_ORDER: { tone: "red", icon: AlertTriangle, label: "OVERDUE ORDER" },
  CANCELLED: { tone: "gray", icon: Circle, label: "CANCELLED" },
  RESERVED: { tone: "blue", icon: Package, label: "RESERVED" },
  "PARTIAL USED": { tone: "amber", icon: AlertTriangle, label: "PARTIAL USED" },
  "ALL USED": { tone: "gray", icon: CheckCircle2, label: "ALL USED" },
  "READY TO TRANSFER": { tone: "amber", icon: Package, label: "READY TO TRANSFER" },
  READY_INSTALL: { tone: "blue", icon: Wrench, label: "READY TO INSTALL" },
  Active: { tone: "blue", icon: Circle, label: "ACTIVE" },
  New: { tone: "gray", icon: Circle, label: "NEW" },
  "OCR Review": { tone: "amber", icon: AlertTriangle, label: "OCR REVIEW" },
  Complete: { tone: "green", icon: CheckCircle2, label: "COMPLETE" },
  Partial: { tone: "amber", icon: AlertTriangle, label: "PARTIAL" },
  Closed: { tone: "gray", icon: Circle, label: "CLOSED" },
};

export default function StatusBadge({ status, testId }) {
  const c = MAP[status] || MAP.WAITING;
  const t = TONE[c.tone];
  const Icon = c.icon;
  return (
    <span
      className="status-pill"
      style={{ backgroundColor: t.bg, color: t.text, borderColor: t.border, boxShadow: t.glow }}
      data-testid={testId}
    >
      <Icon size={12} strokeWidth={2.5} />
      {c.label}
    </span>
  );
}
